export { default as treatment1Mweb1 } from './surveyCreator.png';
export { default as treatment1Mweb2 } from './surveyTaker.png';
